import { Usuario } from './usuario';

export class Venta {
  id: number;
  cliente: string;
  usuario: Usuario;
  comprador: Usuario;
  estado: 'pedida' | 'aceptada' | 'confirmada' | 'editada' | 'despachada' | 'rechazada' | 'cancelada';
  descripcion: string;
  condicion: 'contado' | 'debito' | 'tarjeta' | 'mayorista'
  total: number
  created_at: any
  ped_stock: number;
  ent_stock: number;
  constructor() {
    this.usuario = new Usuario()
    this.estado = 'pedida'
    this.condicion = 'contado'
  }

}